import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constant } from '../../Shared/Models/constant';
import { SOP } from '../Interface/SOP/Sop';

@Injectable({
  providedIn: 'root'
})
export class SopService {
  SOP:Observable<SOP[]>
  private url: string;
  Constants = new Constant();


  private SOPaddnew = this.Constants.localhost_url + 'api/sop'
  private Delete = this.Constants.localhost_url + 'api/sop/'
  private SOPlists = this.Constants.localhost_url + 'api/sopall/'
  private SOPBranchList = this.Constants.localhost_url + 'api/sop-branchid/'
  private SOPDetail = this.Constants.localhost_url + 'api/sop/'
  private SOPEdit = this.Constants.localhost_url + 'api/sop/'
  private ImageDocumentDetail = this.Constants.localhost_url + 'api/get-job-files'
  private SurveyDetail = this.Constants.localhost_url + 'api/job-link-get/'
  private SaveSurveyDeatil = this.Constants.localhost_url+'api/job-upload-link'
  constructor(private httpClient: HttpClient) { }

  SOPnew(SOPdata:Object): Observable<any> {
    
    return this.httpClient.post(`${this.SOPaddnew}`,SOPdata);
  }



   SOPlist(PageNo:string='all',SearchTxt:string,SearchText=''): Observable<any> {
    
    return this.httpClient.get(`${this.SOPlists +SearchTxt +'?page=' + PageNo}&q=${SearchText}`);
  }

  SOPBranchlists(PageNo:string,SearchTxt:string): Observable<any> {
    
    return this.httpClient.get(`${this.SOPBranchList +SearchTxt +'?page=' + PageNo}`);
  }

  SOPGetDetail(id:string): Observable<any> {
    
    return this.httpClient.get(`${this.SOPDetail}`+id);
  }

  GetImageDocumentDetails(id:string): Observable<any>{
    
    return this.httpClient.get(`${this.ImageDocumentDetail}?inspection_id=`+id+'');
  }

  SOPEditDetail(SOPEditData:Object,id:string): Observable<any> {
    
    return this.httpClient.put(`${this.SOPEdit}`+id,SOPEditData);
  }

  
  SOPDelete(id:string): Observable<any> {
    
    return this.httpClient.delete(`${this.Delete}`+id);
  }

  GetSurveyDetails(id:string): Observable<any> {
    
    return this.httpClient.get(`${this.SurveyDetail}`+id);
   // return this.httpClient.get(`${this.SurveyDetail}`+id);
  }
  SaveSurveyDetails(SurveyLinkData): Observable<any>{
    // let header = new HttpHeaders().set(
    //   'Authorization', `Bearer ${localStorage.getItem('token')}`
    // );
    return this.httpClient.post(`${this.SaveSurveyDeatil}`, SurveyLinkData );
    
  }



}
